<template>
  <b-container fluid class="utente">
    <h4>Dettagli account</h4>
    <b-row class="mt-5">
        <b-col sm="6" class="text-right">
            Stato abbonamento:
        </b-col>
        <b-col sm="6" class="text-left">
            <font-awesome-icon icon="file-signature" /> <b>{{stato}}</b>
        </b-col>
    </b-row>
    <b-row>
        <b-col sm="6" class="text-right">
            Scadenza abbonamento:
        </b-col>
        <b-col sm="6" class="text-left">
            <font-awesome-icon icon="calendar-week" /> <b>{{dataScadenza}}</b>
        </b-col>
    </b-row>
    <b-row>
        <b-col sm="6" class="text-right">
            Giorni rimanenti:  
        </b-col>
        <b-col sm="6" class="text-left">
            <font-awesome-icon icon="calendar-day" /> <b>{{giorniRimasti}}</b>
        </b-col>
    </b-row>
    <b-row>
        <b-col sm="6" class="text-right">
            Giorni di utilizzo nel mese corrente:  
        </b-col>
        <b-col sm="6" class="text-left">
            <font-awesome-icon icon="calendar-day" /> <b>{{giorniNelMese}}</b>
        </b-col>
    </b-row>

    <router-link :to="{ name: 'Pagamento' }">
      <b-button variant="outline-success" class="mt-5">
          <font-awesome-icon icon="info-circle" /> RINNOVA ABBONAMENTO
      </b-button>
    </router-link>
          
  </b-container>
</template>

<script>
// import router from '../../router/index.js';
import api from '../../services/service.js'

export default {
  name: 'utente',
  data () {
    return {
      stato: '',
      dataScadenza: '',
      giorniRimasti: '',
      giorniNelMese: ''
    }
  },
  methods: {
  },
  async created() {
    let data = await api.execute('get', 'utente/info');
    this.giorniRimasti = data.giorniRimasti;
    this.stato = data.attivo ? 'ATTIVO' : 'SCADUTO';
    this.dataScadenza = new Date(data.dataScadenza).ddmmyyyy();
    this.giorniNelMese = data.giorniUtilizzoNelMese + (data.attivo ? " giorni" : " giorni su un massimo di 3 giorni");

    this.$parent._data.loaded = true;
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Utente/Utente.vue